import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen w-full flex items-center overflow-hidden" style={{
    backgroundColor: '#0a0a0f'
  }} data-id="element-96">
      {/* Subtle radial gradient overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 30% 50%, rgba(249, 115, 22, 0.06) 0%, transparent 60%)'
    }} data-id="element-97" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-8 py-20 md:py-0" data-id="element-98">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-99">
          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="order-2 lg:order-1" data-id="element-100">
            <p className="text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-6" style={{
            color: '#f97316'
          }} data-id="element-101">
              For corporate professionals who are done being calendar hostages
            </p>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05] text-white mb-6" data-id="element-102">
              Stop Attending Meetings That Should Have Been an Email.
            </h1>

            <p className="text-lg sm:text-xl leading-relaxed mb-10" style={{
            color: '#d4d4d8'
          }} data-id="element-103">
              25 copy-paste scripts to escape, decline, and destroy useless
              meetings — without burning a single bridge.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5" data-id="element-104">
              <motion.a href="#offer" className="cta-glow inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white rounded-lg transition-colors duration-200" style={{
              backgroundColor: '#f97316'
            }} whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.98
            }} data-id="element-105">
                Get The Scripts — $6.39
              </motion.a>
            </div>

            <p className="mt-5 text-sm" style={{
            color: '#a1a1aa'
          }} data-id="element-106">
              Reclaim 10+ hours this week. 7-day money-back guarantee.
            </p>
          </motion.div>

          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-107">
            <div className="relative" data-id="element-108">
              {/* Ambient glow behind image */}
              <div className="absolute -inset-8 rounded-3xl blur-3xl opacity-20 pointer-events-none" style={{
              backgroundColor: '#f97316'
            }} data-id="element-109" />
              <img src="https://cdn.magicpatterns.com/uploads/1oL58sKf7HApg9Hoo5LuuS/heylloyd-image-1771380250632.png" alt="Meeting Mercenary Protocol displayed on a laptop in a dark executive office with a whiskey glass" className="relative rounded-2xl shadow-2xl w-full max-w-lg lg:max-w-xl object-cover" data-id="element-110" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}